import React, { useState, useEffect } from 'react';

interface ImpersonationState {
  isImpersonating: boolean;
  targetUserId: string | null;
  targetUserEmail: string | null;
  originalToken: string | null;
}

export const ImpersonationBanner: React.FC = () => {
  const [impersonation, setImpersonation] = useState<ImpersonationState>({
    isImpersonating: false,
    targetUserId: null,
    targetUserEmail: null,
    originalToken: null,
  });

  // Load impersonation state from localStorage
  useEffect(() => {
    const checkImpersonation = () => {
      const saved = localStorage.getItem('admin_impersonation_state');
      if (saved) {
        try {
          const state = JSON.parse(saved);
          setImpersonation(state);
        } catch (e) {
          console.error('Failed to load impersonation state:', e);
        }
      } else {
        setImpersonation({
          isImpersonating: false,
          targetUserId: null,
          targetUserEmail: null,
          originalToken: null,
        });
      }
    };

    // Check on mount
    checkImpersonation();

    // Check periodically in case it changes in another tab
    const interval = setInterval(checkImpersonation, 1000);

    return () => clearInterval(interval);
  }, []);

  const stopImpersonation = () => {
    console.log('🛑 Stopping impersonation...');
    
    // Clear impersonation state
    localStorage.removeItem('admin_impersonation_state');
    localStorage.removeItem('admin_impersonate_user_id');
    
    // Clean up old impersonation system artifacts (if any)
    localStorage.removeItem('admin_impersonation_token');
    localStorage.removeItem('admin_original_session');
    
    setImpersonation({
      isImpersonating: false,
      targetUserId: null,
      targetUserEmail: null,
      originalToken: null,
    });
    
    console.log('✅ Impersonation stopped. Admin stays logged in.');
    console.log('🔄 Redirecting to home page...');
    window.location.href = '/';
  };

  if (!impersonation.isImpersonating) {
    return null;
  }

  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        backgroundColor: '#ff3333',
        color: 'white',
        padding: '20px 30px',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        borderBottom: '4px solid #cc0000',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <span style={{ fontSize: '32px' }}>👤</span>
          <div>
            <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '4px' }}>
              🚨 ADMIN MODE: IMPERSONATING USER
            </div>
            <div style={{ fontSize: '16px', opacity: 0.95, fontWeight: '500' }}>
              Currently viewing as: {impersonation.targetUserEmail}
            </div>
          </div>
        </div>
        <button
          onClick={stopImpersonation}
          style={{
            backgroundColor: 'white',
            color: '#ff3333',
            border: '3px solid white',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '16px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            transition: 'transform 0.2s',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          🛑 Stop Impersonating
        </button>
      </div>
      {/* Spacer to prevent content from being hidden under fixed banner */}
      <div aria-hidden style={{ height: 84 }} />
    </>
  );
};

